import { useEffect } from "react";
import { useSettings } from "../lib/queries";

/**
 * Injects theme colors from settings into :root CSS vars.
 * Lets the admin change the brand accent live from the dashboard.
 */
export default function ThemeInjector() {
  const { data: s } = useSettings();
  useEffect(() => {
    if (!s) return;
    const root = document.documentElement;
    const map = {
      "--accent": s.theme_accent,
      "--accent-bright": s.theme_accent_bright,
      "--accent-deep": s.theme_accent_deep,
      "--bg-primary": s.theme_bg_primary,
      "--bg-secondary": s.theme_bg_secondary,
      "--cursor-color": s.cursor_color,
    };
    Object.entries(map).forEach(([k, v]) => {
      if (v) root.style.setProperty(k, v);
    });
  }, [s]);
  return null;
}
